import { LoginCard } from "@/projects/components/login-card";

export function AdminLoginPage() {
  return <LoginCard role="admin" />;
}
